/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../../objects/context.js';
import ko from 'knockout';
import _ from 'lodash';
import $ from'jquery';
import utils from '../../../objects/utils';


class saveJobModalModel {

    constructor(params) {
        // Profile
        this.componentName = "save-job-modal";
        this.context = context;
        this.utils = utils;
        this.id = ko.observable(this.context.util.guid());

        this.helpHtml = ko.observable();
        this.helpTitle = ko.observable();
        this.helpTitleCss = ko.observable();

        this.mode = ko.observable('standard');

        this.parentObject = ko.observable({selectedJob:{title:""},saveFormComments:"",saveFormStatusArray:[],saveFormStatus:{}});

        context.eventManager.subscribe((parentObj) =>{
            console.log("event: save-job-modal");
            this.displayModal(parentObj);
        },this, "save-job-modal");

        console.log('save-job-modal:constructor');
    
    }

    displayModal(parentObj) {
        
        this.parentObject(parentObj);
        this.mode(parentObj.mode());
        console.log('save-job-modal:displayModal:  parentObject: %o', this.parentObject());
        console.log('save-job-modal:displayModal:  parentObject.selectedJob.title: %o', this.parentObject().selectedJob.title());
        console.log('save-job-modal:displayModal:  mode: %o', this.mode());

        this.parentObject.valueHasMutated();

        $('#saveJobModal').modal('show');
        this.utils.scrollToTop("#saveJobModal");

        /*
        console.log('save-job-modal:displayModal position: %o', $("#saveJobModal").position());
        console.log('save-job-modal:displayModal offsetHeight: %o', $("#saveJobModal").outerHeight());
        var element = document.getElementById("saveJobModal");
        console.log('save-job-modal:displayModal element: %o', element);
        var xmid = parseInt($("#saveJobModal").outerHeight() / 2);
        
        parent.scrollTo(0,0);
        */
        

        if(this.mode() == "Review")
        {
            this.parentObject().saveFormStatus("8");
            console.log('save-job-modal:displayModal: setting default on select list');
        }

    }

    saveJob() {
        console.log('save-job-modal:saveJob  this: %o', this);
        this.parentObject().saveVersion();
    }


}

export default { viewModel: saveJobModalModel, template: require('!raw-loader!./save-job-modal.html') };


// WEBPACK FOOTER //
// ./src/components/nav-job-list/save-job-modal/save-job-modal.js